/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable import/order */
/* eslint-disable import/no-unresolved */

'use client '

import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { careersSegmentEventCommonPropFunc } from '@utils/carrersSegmentProperties'
import React from 'react'
import Link from 'next/link'
import styles from './button.module.css'
import useIdentifyEvent from '@hooks/useIdentityEvent'

const LinkButton = ({ btnText, btnStyle, btnLink, eventName }) => {
  useIdentifyEvent()
  return (
    <div className={styles.btnContainer}>
      <Link
        href={btnLink}
        className={styles.btn}
        onClick={() => {
          ;(async () => {
            const properties = await careersSegmentEventCommonPropFunc()
            trackEvent('tap_btn_engage', {
              ...properties,
              tab_cta: eventName,
            })
          })()
        }}>
        <button type="button" className={`${styles.btnComponent} ${styles[btnStyle]}`}>
          {btnText}
        </button>
      </Link>
    </div>
  )
}

export default LinkButton
